import { SetStateAction, Dispatch, createContext } from 'react'

type PeriodProps = {
  start?: string | Date
  final?: string | Date
}

export type MiniCalendarType = {
  period?: PeriodProps
  withoutControls?: boolean
  days: Date[]
  view: string
  setView: Dispatch<SetStateAction<string>>
  activeDay: Date | number
  setActiveDay: Dispatch<SetStateAction<Date | number | string>>
  calendarWith6LinesOfDays: boolean
  dataOfTheDays?: any
  DayOfTheMonthComponent?: any
}

const defaultValues = {
  period: {},
  withoutControls: false,
  days: [],
  view: 'MONTH',
  setView: () => {},
  activeDay: 0,
  setActiveDay: () => {},
  calendarWith6LinesOfDays: false,
  dataOfTheDays: {},
  DayOfTheMonthComponent: undefined,
}

const MiniCalendarContext = createContext<MiniCalendarType>(defaultValues)

export default MiniCalendarContext
